var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container",class:_vm.cardClass},[_c('div',{staticClass:"chart"}),(!_vm.series)?_c('BaseLoading'):(_vm.series && _vm.series.values && _vm.series.values.length === 0)?_c('div',[_vm._v(" No data ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }